<template>
    <div>
  <v-toolbar>
    <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
    <v-toolbar-title>要員募集</v-toolbar-title>
  </v-toolbar>
  
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list class="pa-1">
        <v-list-tile avatar>

          <v-list-tile-content>
            <v-list-tile-title>メニュー</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list class="pt-0" dense>
        <v-divider></v-divider>

        <v-list-tile
          v-for="item in items"
          :key="item.title"
          :to="item.link"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        drawer: null,
        items: [
        { title: 'メール送信', link:'/Form'},
        { title: '送信履歴', link:'/History'},
        { title: '宛先管理', link:'/Management'},
        { title: 'ログアウト',link:'/Logout'}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue